/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
import produce from 'immer';
import { retrieveMe } from './actions';

const initialState = {
  error: null,
  item: null,
  loading: false,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case retrieveMe.TRIGGER:
      draft.loading = true;
      draft.error = null;
      break;
    case retrieveMe.SUCCESS:
      draft.item = payload;
      break;
    case retrieveMe.FAILURE:
      draft.error = payload;
      break;
    case retrieveMe.FULFILL:
      draft.loading = false;
      break;
  }
}, initialState);

export default reducer;
